import React from 'react';
import {
    Dropdown as FlowBiteDropdown,
    DropdownProps as FlowBiteDropdownProps,
    DropdownItem as FlowBiteDropdownItem,
    DropdownItemProps as FlowBiteDropdownItemProps,
} from 'flowbite-react';
import { dropdownTheme } from '../../styles/themes/dropdown';
import { useFlowbiteListDemotion } from '../../hooks/use-flowbite-list-demotion';
export type DropdownProps = FlowBiteDropdownProps & {
    ariaLabel?: string;
    testId?: string;
    children: React.ReactNode;
};

export const Dropdown: React.FC<DropdownProps> = (props) => {
    const { ariaLabel, testId, children, ...otherProps } = props;
    return (
        <FlowBiteDropdown data-testid={testId} aria-label={ariaLabel} theme={dropdownTheme} {...otherProps}>
            {children}
        </FlowBiteDropdown>
    );
};

export type DropdownItemProps = FlowBiteDropdownItemProps & {
    ariaLabel?: string;
    testId?: string;
    children: React.ReactNode;
};

export const DropdownItem: React.FC<DropdownItemProps> = (props) => {
    const { ariaLabel, testId, children, role, ...otherProps } = props;
    const buttonRef = React.useRef<HTMLButtonElement>(null);

    // Flowbite hardcodes role="menuitem" on the <li>, nesting two menu items when a role is passed, so demote it.
    React.useLayoutEffect(() => {
        if (!role) {
            return undefined;
        }

        const listItem = buttonRef.current?.closest('li');
        listItem?.setAttribute('role', 'none');

        // Restore flowbite's role for role-less siblings.
        return () => listItem?.setAttribute('role', 'menuitem');
    }, [role]);
    useFlowbiteListDemotion(buttonRef, !!role);

    return (
        <FlowBiteDropdownItem ref={buttonRef} data-testid={testId} aria-label={ariaLabel} role={role} {...otherProps}>
            {children}
        </FlowBiteDropdownItem>
    );
};
